import React from 'react';
import ReactBellIcon from 'react-bell-icon';
import { Link } from 'react-router-dom';

export default function CustomerOrdersSpinner(props) {
  const { userInfo, isTabletOrMobile, notDeliveredItemExist } = props;
  return (
    <div>
      {userInfo &&
        (userInfo.isAdmin || userInfo.isCustomer) &&
        !isTabletOrMobile &&
        (notDeliveredItemExist ? (
          <Link className="nav-link" to="/order/touch?customer=true">
            <div
              className="border border-danger rounded-circle bg-white"
              style={{
                height: '40px',
                width: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ReactBellIcon
                active={false}
                animate={true}
                color="#dc3545"
                width={25}
                height={25}
              />
            </div>
          </Link>
        ) : (
          <Link className="nav-link" to="/order/touch?customer=true">
            <div
              className="border border-green rounded-circle bg-white"
              style={{
                height: '30px',
                width: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ReactBellIcon
                active={false}
                animate={false}
                color="#198754"
                width={20}
                height={20}
              />
            </div>
          </Link>
        ))}
    </div>
  );
}
